import { createContext, useContext, useState } from 'react'

const ContactModalContext = createContext()

export const useContactModal = () => useContext(ContactModalContext)

export const useContactModalProvider = () => {
  const [open, setOpen] = useState(false)
  const [showEmailInput, setShowEmailInput] = useState(false)
  const [email, setEmail] = useState('')

  const openModal = () => setOpen(true)

  const closeModal = () => {
    setOpen(false)
    setShowEmailInput(false)
    setEmail('')
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) closeModal()
  }

  const handleReceiveCv = () => setShowEmailInput(true)

  const handleSend = () => {
    // logic to implement later
    setShowEmailInput(false)
    setEmail('')
  }

  return {
    open,
    showEmailInput,
    email,
    setEmail,
    openModal,
    closeModal,
    handleOverlayClick,
    handleReceiveCv,
    handleSend,
  }
}

export default ContactModalContext
